import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Logo } from './Logo'

interface PageLayoutProps {
  title: string
  lastUpdated?: string
  children: React.ReactNode
}

export function PageLayout({ title, lastUpdated, children }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="transition-transform duration-300 group-hover:scale-105">
              <Logo size={36} />
            </div>
            <div className="flex flex-col">
              <span className="text-gray-900 font-semibold text-base leading-tight">SecBrain</span>
              <span className="text-teal-600 text-[9px] font-medium tracking-wide uppercase">Neurodivergente</span>
            </div>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12 lg:py-16">
        <div className="mb-8">
          <h1 className="text-3xl lg:text-4xl font-semibold text-gray-900 mb-2">{title}</h1>
          {lastUpdated && (
            <p className="text-gray-500 text-sm">Última atualização: {lastUpdated}</p>
          )}
        </div>
        <div className="legal-content">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 py-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} SecBrain Neurodivergente. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  )
}
